import makeStyles from "@mui/styles/makeStyles";

const styles = makeStyles(() => ({
  tooltipContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "6px",
    maxWidth: "360px",
  },
  tooltipTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "6px",
    width: "100%",
  },
  tooltipText: {
    flex: 1,
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: 1.4,
  },
  tooltipIcon: {
    flexShrink: 0,
    marginTop: "2px",
  },
}));

export default styles;
